import Typography from '@/components/next-ui/Typography';
import { cx } from 'cva';
import { isEmpty, throttle } from 'lodash-es';
import Image from 'next/image';
import React, { useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { MdClose, MdOutlineCloudUpload } from 'react-icons/md';

const fileSizeLimit = {
  size: 1024 * 1024 * 10, // 10MB
  message: 'File size should be less than 10MB',
};

function SingleImageSelector(props) {
  const { autoOpen = false, onChange, error, value = null } = props;
  const [rejectedFiles, setRejectedFiles] = React.useState([]);

  const updateSelectedImage = (image) => {
    onChange(image);
  };

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    accept: 'image/*',
    multiple: false,
    maxSize: fileSizeLimit.size,
    maxFiles: 1,
    onDrop: (accepted, rejected) => {
      if (accepted.length > 0) {
        updateSelectedImage(
          Object.assign(accepted[0], {
            preview: URL.createObjectURL(accepted[0]),
          }),
        );
      } else if (rejected.length > 0) {
        setRejectedFiles(rejected);
      }
    },
  });

  const autoOpenFileDialog = useCallback(
    throttle(() => {
      setTimeout(() => {
        open();
      }, 100);
    }, 5000),
    [],
  );

  useEffect(() => {
    if (autoOpen) {
      autoOpenFileDialog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-full w-full flex-col items-start justify-center gap-3">
      <div
        className={cx(
          'flex w-full flex-col items-center justify-start rounded-md bg-primary-light-1 p-8',
          isDragActive && 'shadow-md',
        )}
        {...getRootProps()}>
        <input {...getInputProps()} name="imageFile" />
        <MdOutlineCloudUpload className="h-12 w-12 text-primary" />
        <Typography variant="h4" className="mt-4">
          Drop your files here or click to select files
        </Typography>
      </div>

      {error && (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      )}

      {!isEmpty(value) && (
        <div className="flex w-[200px] flex-col items-start gap-2">
          <div className="relative h-[118px] w-full">
            <Image
              src={value.preview || ''}
              alt="selected image"
              fill
              className="rounded object-cover"
            />
            <button
              className="p-0.25 -translate-x-0.25 translate-y-0.25 absolute right-0 top-0 transform rounded-full bg-white"
              onClick={() => onChange(null)}>
              <MdClose className="h-4 w-4 text-secondary" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SingleImageSelector;
